import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppContext, ToastrContext } from '../../contexts';
import Card from '../../components/elements/Card';
import Button from '../../components/elements/Button';
import TextField from '../../components/fields/Text';
import IconAdd from '../../components/icons/IconAdd';
import ScrollToTop from '../../components/elements/ScrollToTop';
import DataTable from '../../components/elements/DataTable';
import IconPencil from '../../components/icons/IconPencil';
import IcDelete from '../../components/icons/IcDelete';
import { useDebounce } from '../../utils/hooks';
import {
  fetchAreaManagement,
  createAreaManagement,
  editAreaManagement,
  removeAreaManagement,
  setAction,
} from './actions';
import FormAreaManagement from '../../components/forms/FormAreaManagement';
import { ActionIcon, Group, Modal, Stack, Text } from '@mantine/core';
import { toastMessage } from './constants';

import styles from './styles.scoped.css';

export default function AreaManagement() {
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [modalAct, setModalAct] = useState(false);
  const [detail, setDetail] = useState({});
  const [showTable, setShowTable] = useState(true);
  const {
    dataAreaManagement,
    dataSubmitAreaManagement,
    dataSubmitUpdateAreaManagement,
    isLoadingAreaManagement,
    isLoadingSubmitAreaManagement,
    isLoadingSubmitUpdateAreaManagement,
    messageSubmitAreaManagement,
    messageSubmitUpdateAreaManagement,
    action,
  } = useSelector((state) => state.areaManagement);
  const { data, meta } = dataAreaManagement;
  const debouncedSearch = useDebounce(search, 500);

  const column = [
    { heading: 'Kode', value: 'code', className: '' },
    {
      heading: 'Nama Wilayah',
      value: 'name',
      className: styles['name-column'],
    },
    { heading: 'Tanggal', value: 'date', className: '' },
    {
      heading: 'Action',
      value: (value) => renderActionDisplay(value),
      className: '',
    },
  ];

  const openModalEdit = (value) => {
    setDetail({ code: value.code, name: value.name, id: value.id });
    setModalAct('edit');
  };
  const openModalDelete = (value) => {
    setDetail({ id: value.id });
    setModalAct('delete');
  };
  const openModalAdd = () => {
    setDetail({ code: '', name: '' });
    setModalAct('add');
  };
  const handleSubmit = (payload) => {
    if (!detail.code) {
      dispatch(setAction('add'));
      dispatch(createAreaManagement(payload));
    } else {
      dispatch(setAction('edit'));
      dispatch(editAreaManagement(payload));
    }
    setModalAct('');
  };
  const handleDelete = () => {
    dispatch(setAction('delete'));
    dispatch(removeAreaManagement(detail.id));
    setModalAct('');
  };

  const fetchListAreaManagementUser = (scrollId) => {
    dispatch(fetchAreaManagement(scrollId, search));
  };

  const renderActionDisplay = (value) => {
    return (
      <div className={styles.actionContainer}>
        <ActionIcon onClick={() => openModalEdit(value)} title={'Edit'}>
          <IconPencil style={{ fill: 'white' }} />
        </ActionIcon>
        <ActionIcon
          bg={'red'}
          onClick={() => openModalDelete(value)}
          title={'Delete'}
        >
          <IcDelete style={{ fill: 'white' }} />
        </ActionIcon>
      </div>
    );
  };

  useEffect(() => {
    setBreadcrumbs(['Manajemen Wilayah']);

    return () => {
      dispatch(setAction(''));
    };
  }, []);

  useEffect(() => {
    fetchListAreaManagementUser();
  }, [
    debouncedSearch,
    isLoadingSubmitAreaManagement,
    isLoadingSubmitUpdateAreaManagement,
  ]);

  useEffect(() => {
    if (!isLoadingAreaManagement && data.length === 0) {
      setShowTable(false);
    } else setShowTable(true);
  }, [data, isLoadingAreaManagement]);

  useEffect(() => {
    if (action) {
      if (
        (!isLoadingSubmitAreaManagement && dataSubmitAreaManagement) ||
        (!isLoadingSubmitUpdateAreaManagement && dataSubmitUpdateAreaManagement)
      ) {
        setToastr({
          desc: toastMessage[action]['success'],
          type: 'success',
          visible: true,
        });
      } else if (
        (!isLoadingSubmitAreaManagement && messageSubmitAreaManagement) ||
        (!isLoadingSubmitUpdateAreaManagement &&
          messageSubmitUpdateAreaManagement)
      ) {
        setToastr({
          desc:
            messageSubmitAreaManagement || messageSubmitUpdateAreaManagement,
          type: 'danger',
          visible: true,
        });
      }
    }
  }, [
    dataSubmitAreaManagement,
    isLoadingSubmitAreaManagement,
    messageSubmitAreaManagement,
    dataSubmitUpdateAreaManagement,
    isLoadingSubmitUpdateAreaManagement,
    messageSubmitUpdateAreaManagement,
    action,
  ]);

  return (
    <div className={styles.root}>
      <Card className={styles.toolBox}>
        <Button
          className={styles.button}
          onClick={() => openModalAdd()}
        >
          <IconAdd style={{ fill: '#FFFFFF' }} />
          <span>Tambah Data Wilayah Whitelist</span>
        </Button>
        <form className={styles.searchForm}>
          <TextField
            hideLabel
            inputProps={{
              placeholder: 'Cari data...',
              value: search,
              icon: 'ic-search.svg',
              onChange: (e) => setSearch(e.target.value),
            }}
          />
        </form>
      </Card>
      {showTable ? (
        <Card>
          <div className={styles['table-container']}>
            <DataTable
              className={styles.table}
              column={column}
              data={data}
              endTreshould={500}
              loading={isLoadingAreaManagement}
              meta={meta}
              onEndReached={() => fetchListAreaManagementUser(meta.page + 1)}
              onRefresh={fetchListAreaManagementUser}
              withIndex
            />
          </div>
        </Card>
      ) : (
        <Card>
          <Group h={'60dvh'} p={'1rem'} position="center" spacing="xs">
            <img alt="Empty Document" src="/assets/illu-empty-document.svg" />
            <Stack spacing="xs">
              <Text fw={500} fz={'1.5rem'}>
                Belum ada data wilayah
              </Text>
              <Text fz={'1.125rem'}>
                Tambah data wilayah baru untuk whitelist Permendagri
              </Text>
              <Button
                className={`${'button'} ${styles['btn-fit']}`}
                onClick={() => openModalAdd()}
                style="outlined"
              >
                <IconAdd style={{ fill: 'blue' }} />
                <span>Tambah Data Wilayah Whitelist</span>
              </Button>
            </Stack>
          </Group>
        </Card>
      )}
      <ScrollToTop />
      <Modal
        centered
        onClose={() => setModalAct('')}
        opened={modalAct === 'add' || modalAct === 'edit'}
        size="lg"
        withCloseButton={false}
      >
        <FormAreaManagement
          handleClose={() => setModalAct('')}
          initialValues={detail}
          onSubmit={handleSubmit}
        />
      </Modal>
      <Modal
        centered
        onClose={() => setModalAct('')}
        opened={modalAct === 'delete'}
        size="lg"
      >
        <Text fw={500} fz={'1.5rem'} ta={'center'}>
          Apakah kamu yakin akan menghapus Wilayah ini?
        </Text>
        <Group grow mt={'1.5rem'} spacing={'sm'}>
          <Button onClick={() => setModalAct('')} style={'outlined'}>
            Batal
          </Button>
          <Button onClick={handleDelete} style={'blue'}>
            Hapus
          </Button>
        </Group>
      </Modal>
    </div>
  );
}
